export default __webpack_public_path__ + "static/media/project3.0ace3b68.jpeg";